import React, { Component } from 'react';
import NombreProducto from './NombreProducto';
import Marca from './Marca';
import EstaHabilitado from './EstaHabilitado';
import Titulo from '../Titulo';

import { GenericSimpleButton, GenericSimpleIconButton } from 'com-gyf-webcore-userinterfacecomponents';
import { selectRadio } from '../../actions/Actions';


class DatosGenerales extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cancelProduct: props.cancelProduct,
        }
        this.cancelProduct = this.cancelProduct.bind(this);
        this.validateAddProduct = this.validateAddProduct.bind(this);
    }

    cancelProduct() {
        this.state.cancelProduct();
    }

    validateAddProduct() {
        this.props.validateAddProduct(this.props.data, this.props.form);
    }

    render() {
        let { data, selectCheckBox, changeInput, form, children, selectRadio } = this.props;

        let saveButton = null;
        let cancelButton = null;
        if (data.readyRequest) {
            saveButton = <GenericSimpleIconButton text="Guardado en proceso... " buttonClass="btn btn-cta disabled" iconClass="fa fa-circle-o-notch fa-spin" />
        }
        else {
            saveButton = <GenericSimpleButton buttonType="button" text="Aceptar" buttonClass="btn btn-cta" onClick={this.validateAddProduct} />
            cancelButton = <GenericSimpleButton
                buttonType="button"
                text="Cancelar"
                buttonClass="btn btn-secondary"
                onClick={this.cancelProduct} />
        }
        let title = data.edicion ? "Editar Producto" : "Nuevo Producto";

        return (
            <div className="col-xs-12 tarjetas">
                <div className="row">
                    <div className="col-xs-12">
                        <h1>
                            {title}
                        </h1>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-2">
                        {saveButton}
                    </div>
                    <div className="col-xs-2">
                        {cancelButton}
                    </div>
                    <div className="col-xs-9"></div>
                </div>
                <Titulo titulo="Datos Generales del Producto" />
                <NombreProducto
                    nombre={data.Nombre}
                    edicion={data.edicion}
                    ERROR_PRODUCT={data.ERROR_PRODUCT}
                    changeInput={changeInput}
                />
                <EstaHabilitado
                    data={data}
                    selectCheckBox={selectCheckBox} />

                <Marca data={data} getDataByAdministratorId={this.props.getDataByAdministratorId} selectRadio={selectRadio} />

                {children}

            </div>
        );
    }
};
 
export default DatosGenerales;